const filterSectionList = (
  sectionList,
  searchTerm,
  isHideCompletedChecked,
  isHideIncompleteChecked,
  selectedCategories
) => {
  let filteredSectionList = [];

  // Filter by search term
  if (searchTerm.length > 0) {
    filteredSectionList = sectionList.filter((sectionItem) => {
      return sectionItem.sectionTitle
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
    });
  } else {
    filteredSectionList = sectionList;
  }

  // Filter by completed/incomplete
  let tempSectionList = [];
  if (isHideCompletedChecked || isHideIncompleteChecked) {
    filteredSectionList.forEach((sectionValue) => {
      if (isHideCompletedChecked && sectionValue.Completed) {
        // Do nothing
      } else if (isHideIncompleteChecked && !sectionValue.Completed) {
        // Do nothing
      } else {
        tempSectionList.push(sectionValue);
      }
    });
  } else {
    tempSectionList = filteredSectionList;
  }

  // Filter by category
  let newTempSectionList = [];
  tempSectionList.forEach((sectionValue) => {
    if (selectedCategories.includes(sectionValue.sectionCategory)) {
      newTempSectionList.push(sectionValue);
    }
  });

  return newTempSectionList;
};

export default filterSectionList;
